<template>
  <preview :ad-count="2" :edited-business-details="editedBusinessDetails" />
</template>

<script>
import Preview from './Preview.vue';
import { mapGetters } from 'vuex';
import { businessDetailsMacros, bizgainOnboardingImage, bizgainOnboardingRoutes, objectiveType } from 'Features/bizgainOnboarding/constants';
import onboardingRedirect  from 'Mixins/onboardingRedirect';
export default {
  mixins: [onboardingRedirect],
  created() {
    this.editedBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
    this.services = this.promoteServices;
    this.isSingleServiceSelected = Array.isArray(this.services) && this.services.length === 1;
    this.getTextAds();
  },
  components: {
    Preview
  },
  data() {
    return {
      services: [],
      descriptionNo: 1,
      serviceNo: 0,
      textAds: [],
      globeImg: bizgainOnboardingImage.globe,
      bizgainOnboardingRoutes,
      isSingleServiceSelected: false,
      objectiveType,
      isUpdateLaunchState: false,
      editedBusinessDetails: {}
    }
  },
  methods: {
    getTextAds() {
      let count = 2
      this.textAds = [];
      if(Array.isArray(this.services) && this.services.length === 1) {
        count = 2;
      }
      let details = this.businessDetails.creativeDetail.adDetail.textAd;
      for(let i = 0; i < count; i++) {
        let description = this.descriptionNo == 1 ?  details.description1 : details.alternativeDescription1
        let macro = description.includes(businessDetailsMacros.services) ? businessDetailsMacros.services : businessDetailsMacros.alternateServices;
        if(!this.isSingleServiceSelected || description.includes(macro)){
          description = description.replace(macro, this.services[this.serviceNo]);
        }
        this.textAds.push({ description })
        this.serviceNo = (this.serviceNo + 1) % this.services.length;
        if(this.serviceNo == 0 && this.services.length % 2 == 0) {
          this.services.unshift(this.services.pop());
        }
        this.descriptionNo = this.descriptionNo == 1 ? 2 : 1;
      }
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'promoteServices', 'objective', 'isInAppCampaign', 'roimaticCampaignId', 'businessProfileId', 'signUpRequest']),
    textAd(){
      return this.businessDetails.creativeDetail.adDetail.textAd;
    }
  }
}
</script>

<style lang="scss" scoped>

  .text-end {
    text-align: end;
  }
</style>